import React from "react";
import ReactDOM from "react-dom";
import "./ProjectContextMenu.css";
import archiveIcon from "../../assets/archive.svg";
import deleteIcon from "../../assets/delete.svg";
import renameIcon from "../../assets/edit.svg";
import shareIcon from "../../assets/shareIcon.svg";
import coverIcon from "../../assets/image.svg";

const ProjectContextMenu = React.forwardRef(
  (
    {
      posterUrl,
      projectId,
      isShared = false,
      onArchive,
      onRestore = () => {},
      isArchive,
      onDelete,
      onRemoveFromShared = () => {},
      onOpenShare = () => {},
      onRename,
      onChangeCover,
      onClose,
      style = {},
      className = "",
      usePortal = false,
    },
    ref
  ) => {
    const menu = (
      <div
        className={`project-context-menu ${className}`}
        style={style}
        ref={ref}
      >
        <div className="context-project-list">
          {!isArchive && !isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                onRename(e);
                onClose();
              }}
            >
              <img
                src={renameIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">Переименовать</span>
            </div>
          )}
          {!isArchive && !isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onOpenShare(e);
                onClose();
              }}
            >
              <img
                src={shareIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">Поделиться</span>
            </div>
          )}
          {!isArchive && !isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                onChangeCover(e);
                onClose();
              }}
            >
              <img
                src={coverIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">
                {posterUrl ? "Сменить обложку" : "Загрузить обложку"}
              </span>
            </div>
          )}
          {isArchive && !isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                onRestore(e);
                onClose();
              }}
            >
              <img
                src={archiveIcon}
                ѕ
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">Восстановить</span>
            </div>
          )}
          {!isArchive && !isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                onArchive(e);
                onClose();
              }}
            >
              <img
                src={archiveIcon}
                ѕ
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">В архив</span>
            </div>
          )}
          {!isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                onDelete(e);
                onClose();
              }}
            >
              <img
                src={deleteIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">Удалить</span>
            </div>
          )}
          {isShared && (
            <div
              className="context-project-item"
              onClick={(e) => {
                onRemoveFromShared(e);
                onClose();
              }}
            >
              <img
                src={deleteIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-project-text">Удалить из доступных</span>
            </div>
          )}
        </div>
      </div>
    );
    if (usePortal) {
      return ReactDOM.createPortal(menu, document.body);
    }
    return menu;
  }
);

export default ProjectContextMenu;
